import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataAPI, postDataAPI } from "../utils/fetchData";

export default function VideoAction(props) {
	const { auth } = useSelector((state) => state);
	const dispatch = useDispatch();
	const [showUploadVideoModal, setShowUploadVideoModal] = useState(false);
	const [dlCategorieArray, setDlCategorieArray] = useState([]);
	const [dlSubCategorieArray, setDlSubCategorieArray] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState("");
	const [selectedSubCategory, setSelectedSubCategory] = useState("");
	const [videoName, setVideoName] = useState("");
	const [duration, setDuration] = useState(0);
	// const [videoSubject, setVideoSubject] = useState("");
	const [videoSource, setVideoSource] = useState("");
	// const [numberOfPages, setNumberOfPages] = useState(0);
	const [videoLink, setVideoLink] = useState("");
	const [selectedLanguage, setSelectedLanguage] = useState("");
	const [languages, setLanguages] = useState([]);

	useEffect(() => {
		// getDataAPI(`getdlcategory`).then((res) => {
		// 	// console.log("dlcategoryarray", res.data.categories);
		// 	// setCommunitiesArray(res.data.community);
		// 	setDlCategorieArray(res.data.categories);
		// });
		// getDataAPI(`getlanguages`, auth.token).then((res) => {
		// 	// console.log("res getlanguages", res.data);
		// 	// setCommunitiesArray(res.data.community);
		// 	setLanguages(res.data.languages);
		// });
		setDlCategorieArray(props.categoriesArray);
		setLanguages(props.languagesArray);
	}, [props]);

	useEffect(() => {
		if (selectedCategory !== "") {
			getDataAPI(`getdlsubcategory/${selectedCategory}`).then((res) => {
				// console.log("res getdl subcategory", res.data);
				// setCommunitiesArray(res.data.community);
				setDlSubCategorieArray(res.data.subcategories);
			});
		}
	}, [selectedCategory]);

	const handleEditVideo = async (video) => {
		console.log("video", video);
		setVideoName(video.name);
		setSelectedCategory(video.categoryid);
		setSelectedSubCategory(video.subcategoryid);
		setSelectedLanguage(video.languageid);
		// setVideoSubject(video.subject);
		setVideoSource(video.source);
		setDuration(video.duration);
		setVideoLink(video.link);

		setTimeout(() => {
			setShowUploadVideoModal(true);
		}, 100);
	};

	const handleSetVideoInactive = async (video) => {
		console.log("video", video);
		getDataAPI(`inactivevideo/${video.id}`, auth.token).then((res, err) => {
			console.log("res inactivevideo", res.data);
			if (err) {
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { error: err.response.data.msg },
				});
			}
			if (res.status === 200) {
				window.location.reload();
			}
			// setMycommunitiesArray(res.data.community);
		});
	};

	const handleUploadVideo = async () => {
		dispatch({
			type: GLOBALTYPES.ALERT,
			payload: { loading: true },
		});
		setShowUploadVideoModal(false);

		let item = {
			id: props.video.id,
			name: videoName,
			categoryid: selectedCategory,
			subcategoryid: selectedSubCategory,
			languageid: selectedLanguage,
			// subject: videoSubject,
			source: videoSource,
			duration: duration,
			link: videoLink,
			communityid: "9ae8b71c-dd3f-4fad-b1ee-e872f951e7af",
		};
		console.log("item", item);
		const formData = new FormData();

		for (var key in item) {
			formData.append(
				key,
				typeof item[key] === "object" ? JSON.stringify(item[key]) : item[key]
			);
		}
		try {
			const res = await postDataAPI("updatevideo", formData, auth.token);
			console.log("res", res.data);
			if (res.status === 200) {
				setTimeout(() => {
					window.location.reload();
				}, 1000);
			}
		} catch (err) {
			dispatch({
				type: GLOBALTYPES.ALERT,
				payload: { error: err.response.data.msg },
			});
		}
	};

	return (
		<>
			<Modal
				show={showUploadVideoModal}
				onHide={() => setShowUploadVideoModal(false)}
				dialogClassName="modal-sm-30px"
				size="md"
				backdropClassName="childmodal"
				// backdrop="static"
				centered
				// onEntered={() => props.handleEntered}
			>
				<Modal.Body style={{ padding: "0px 12px 0px 12px" }}>
					<div className="row">
						<div className="col-11">
							<h2
								style={{
									fontSize: "18px",
									fontWeight: "500",
									padding: "10px",
								}}>
								Add Video
							</h2>
						</div>
						<div
							className="col-1"
							style={{ padding: "10px", cursor: "pointer" }}
							onClick={() => setShowUploadVideoModal(false)}>
							<img alt="close" src="../images/closeOne.png"></img>
						</div>
					</div>
					<hr style={{ marginTop: "0px" }} />
					<div className="uc-modal-body">
						<div className="uc-detail-btn-wrap uc-share-btn-wrap">
							<div style={{ paddingLeft: "10px" }}>
								<div style={{ fontSize: "13px" }}>Categorie:</div>
								<select
									name="category"
									defaultValue={selectedCategory}
									onChange={(e) => setSelectedCategory(e.target.value)}>
									<option value="">Select</option>
									{dlCategorieArray.map((e) => {
										return (
											<option value={e.id} key={e.id}>
												{e.name}
											</option>
										);
									})}
								</select>
								<span style={{ marginLeft: "30px" }}>
									<Button
										onClick={() => {
											props.categories();
											// setShowCategorieModal(true);
											// setShowUploadModal(false);
										}}
										style={{ background: "#20ce8f", border: "none" }}>
										Add
									</Button>
								</span>
							</div>

							<div style={{ paddingLeft: "10px" }}>
								<div style={{ fontSize: "13px" }}>Sub Categorie:</div>
								<select
									name="subcategory"
									defaultValue={selectedSubCategory}
									onChange={(e) => setSelectedSubCategory(e.target.value)}>
									<option value="">Select</option>
									{dlSubCategorieArray.map((e) => {
										return (
											<option value={e.id} key={e.id}>
												{e.name}
											</option>
										);
									})}
								</select>
								<span style={{ marginLeft: "30px" }}>
									<Button
										onClick={() => {
											props.subcategories();
											// setShowSubCategorieModal(true);
											// setShowUploadModal(false);
										}}
										style={{ background: "#20ce8f", border: "none" }}>
										Add
									</Button>
								</span>
							</div>

							<div style={{ paddingLeft: "10px" }}>
								<div style={{ fontSize: "13px" }}>Language:</div>
								<select
									name="language"
									value={selectedLanguage}
									onChange={(e) => setSelectedLanguage(e.target.value)}>
									<option value="">Select</option>
									{languages.map((e) => {
										return (
											<option value={e.id} key={e.id}>
												{e.name}
											</option>
										);
									})}
								</select>
								<span style={{ marginLeft: "30px" }}>
									<Button
										onClick={() => {
											props.languages();
											// setShowLanguageModal(true);
											// setShowUploadModal(false);
										}}
										style={{ background: "#20ce8f", border: "none" }}>
										Add
									</Button>
								</span>
							</div>

							<div className="row pb-2 mt-2">
								<div className="col-12">
									<input
										type="text"
										className="form-control"
										id="copytext"
										value={videoName}
										placeholder="Video Name"
										style={{ backgroundColor: "#fff" }}
										onChange={(e) => setVideoName(e.target.value)}
									/>
								</div>
							</div>
							{/* <div className="row pb-2">
								<div className="col-12">
									<input
										type="text"
										className="form-control"
										id="copytext"
										placeholder="Category"
										style={{ backgroundColor: "#fff" }}
										onChange={(e) => setVideoCategory(e.target.value)}
									/>
								</div>
							</div> */}

							{/* <div className="row pb-2">
								<div className="col-12">
									<input
										type="text"
										className="form-control"
										id="copytext"
										value={videoSubject}
										placeholder="Subject"
										style={{ backgroundColor: "#fff" }}
										onChange={(e) => setVideoSubject(e.target.value)}
									/>
								</div>
							</div> */}
							<div className="row pb-2">
								<div className="col-12">
									<input
										type="text"
										className="form-control"
										id="copytext"
										value={videoSource}
										placeholder="Source"
										style={{ backgroundColor: "#fff" }}
										onChange={(e) => setVideoSource(e.target.value)}
									/>
								</div>
							</div>
							<div className="row pb-2">
								<div className="col-12">
									<input
										type="number"
										className="form-control"
										id="copytext"
										value={duration}
										placeholder="Duration in minutes"
										style={{ backgroundColor: "#fff" }}
										onChange={(e) => setDuration(e.target.value)}
									/>
								</div>
							</div>

							<div className="row pb-2">
								<div className="col-12">
									<input
										type="text"
										className="form-control"
										id="copytext"
										placeholder="Link"
										value={videoLink}
										style={{ backgroundColor: "#fff" }}
										onChange={(e) => setVideoLink(e.target.value)}
									/>
								</div>
							</div>

							{/* <div>Source:</div>
							<div className="row pb-2">
								<div className="col-12">
									<input
										type="file"
										accept="video/*"
										className="form-control"
										id="copytext"
										onChange={(e) => setVideoFile(e.target.files[0])}
										style={{ backgroundColor: "#fff" }}
									/>
								</div>
							</div> */}
						</div>
						<div
							className="row"
							style={{
								backgroundColor: "#efefef",
								padding: "10px 10px",
								marginTop: "15px",
							}}>
							<div
								className="col-10"
								style={{
									display: "flex",
									alignItems: "center",
									justifyContent: "flex-start",
									visibility: "hidden",
								}}>
								<input type="checkbox" id="file" />
								&nbsp;&nbsp;&nbsp; Make announcement post
							</div>

							<div className="col-2">
								<div>
									<Button
										style={{
											background: "#3CCE8F",
											border: "none",
											height: "35px",
											//   width:"40px",
											borderRadius: "15px",
											//   display:"flex",
											//   alignItems:"center",
											//   justifyContent:"end"
										}}
										onClick={() => handleUploadVideo()}>
										Upload
									</Button>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
			</Modal>

			<div>
				<Button
					style={{
						// background:
						// 	"#E23F1C",
						fontSize: "13px",
						borderRadius: "4px",
						border: "none",
					}}
					className="btn btn-warning mt-2 col-12"
					onClick={() => handleEditVideo(props.video)}>
					<i className="fas fa-edit"></i>
					Edit video
				</Button>
				<Button
					style={{
						background: "#E23F1C",
						fontSize: "13px",
						borderRadius: "4px",
						border: "none",
					}}
					className="btn btn-danger mt-2 col-12"
					onClick={() => handleSetVideoInactive(props.video)}>
					<i className="fa fa-trash" aria-hidden="true"></i> Delete video
				</Button>
			</div>
		</>
	);
}
